<h5>Gestione richiesta</h5>

<div class="row mt-4 mb-4">

    <div class="col">

        <mat-card appearance="outlined" class="p-0 gestione-richiesta-card">

            <mat-card-content>
                <p>
                    <b>Setting:</b> {{statoRichRepsponse?.setting?.descrizione}}<br>
                </p>
                <div class="workflow-context mt-2 mb-2">
                    <p class="mb-1"><b>Stato corrente:</b> <span class="stato-corrente">{{stato}}</span></p>
                    <p class="mb-1" *ngIf="statoRichRepsponse?.statoPrecedenteDescrizione">
                        <b>Stato precedente:</b> {{statoRichRepsponse?.statoPrecedenteDescrizione}}
                    </p>
                    <p class="mb-1" *ngIf="!statoRichRepsponse?.statoPrecedenteDescrizione">
                        <b>Stato precedente:</b> -
                    </p>
                    <p class="mb-0" *ngIf="statoRichRepsponse?.prossimiPossibili?.length">
                        <b>Prossimi possibili:</b>
                        <span class="prossimi-possibili">
                            <ng-container *ngFor="let p of statoRichRepsponse?.prossimiPossibili; let last = last">
                                <span class="badge-stato">{{ p.descrizione || p.codice }}</span><span *ngIf="!last">, </span>
                            </ng-container>
                        </span>
                    </p>
                    <p class="mb-0" *ngIf="!statoRichRepsponse?.prossimiPossibili?.length && statoRichRepsponse?.statoId">
                        <b>Prossimi possibili:</b> -
                    </p>
                </div>
            </mat-card-content>

            <hr>

            <mat-card-content>

                <div *ngIf="stato === 'Letta'">
                    <p>Richiesta UVM? {{ ulterioreDato || '-' }}</p>
                    <p>Attivare UVM?</p>
                    <div class="d-flex">
                        <div style="margin-right: 0.5rem;">
                            <button mat-flat-button (click)="nextStep()">Si</button>
                        </div>
                        <div>
                            <button mat-stroked-button (click)="nextStepNo()">No</button>
                        </div>
                    </div>
                </div>

                <div *ngIf="stato?.toLowerCase() === 'in carico'">
                    <app-mirko3 [idRichiesta]="this.idRichiesta" (valueChanged)="refreshState($event)"></app-mirko3>
                </div>

                <div *ngIf="stato?.toLowerCase() === 'in attesa'">
                    <p>Forza conferma proposta calendarizzazione UVM?</p>
                    <div class="d-flex">
                        <div style="margin-right: 0.5rem;">
                            <button mat-flat-button (click)="nextStep()">Si</button>
                        </div>
                        <div>
                            <button mat-stroked-button>No</button>
                        </div>
                    </div>
                </div>


                <div *ngIf="stato?.toLowerCase() === 'attesa conferma calendarizzazione uvm'">
                    <p>Confermare manualmente la sessione UVM scelta?</p>
                    <div class="d-flex">
                        <div style="margin-right: 0.5rem;">
                            <button mat-flat-button (click)="nextStep()">Conferma e continua</button>
                        </div>
                    </div>
                </div>


                <!--------------------------------------------------->

                <!--<div *ngIf="stato?.toLowerCase() === 'attesa esito uvm'">
                    <p>Forza esito UVM</p>
                    <mat-form-field class="example-full-width">
                        <mat-label>JSON</mat-label>
                        <textarea [(ngModel)]="textInput" matInput
                            placeholder="Inserire json setNotificaCambioSetting">Inserire json setNotificaCambioSetting</textarea>
                    </mat-form-field>
                    <div class="d-flex">
                        <div style="margin-right: 0.5rem;">
                            <button mat-flat-button (click)="sendJsonNotificaCambioSetting()">Invia</button>
                        </div>
                    </div>
                </div>-->

                <!--------------------------------------------------->



                <div
                    *ngIf="((stato?.toLowerCase() === 'valutata da uvm' || stato?.toLowerCase() === 'senza uvm') && (statoRichRepsponse?.setting?.codice === '1'))">
                    <app-scelta-pde [idRichiesta]="this.idRichiesta"
                        (valueChanged)="refreshState($event)"></app-scelta-pde>

                    <div class="d-flex" *ngIf="showPDE">
                        <div style="margin-right: 0.5rem;">
                            <button mat-flat-button (click)="nextStep()">Conferma e continua</button>
                        </div>
                    </div>

                </div>



                <div
                    *ngIf="((stato?.toLowerCase() === 'valutata da uvm' || stato?.toLowerCase() === 'senza uvm') && (statoRichRepsponse?.setting?.codice === '3' || statoRichRepsponse?.setting?.codice === '4' || statoRichRepsponse?.setting?.codice === '5' || statoRichRepsponse?.setting?.codice === '6'))">


                    <!-- 
                      
                        <app-scelta-pde [idRichiesta]="this.idRichiesta"
                        (valueChanged)="refreshState($event)"></app-scelta-pde>

                        <div class="d-flex" *ngIf="showPDE">
                            <div style="margin-right: 0.5rem;">
                                <button mat-flat-button (click)="nextStep()">Conferma e continua</button>
                            </div>
                        </div>

                    -->

                    <app-scelta-pde-struttura [idRichiesta]="this.idRichiesta" (valueChanged)="nextStep()">
                    </app-scelta-pde-struttura>
                </div>


                <div *ngIf="stato?.toLowerCase() === 'attesa conferma pde'">
                    <div class="alert alert-info mb-3" role="alert">
                        <strong>In attesa.</strong> La richiesta è in attesa di conferma del PDE scelto. Confermare manualmente per procedere.
                    </div>
                    <p>Confermare manualmente PDE scelto?</p>
                    <div class="d-flex">
                        <div style="margin-right: 0.5rem;">
                            <button mat-flat-button (click)="nextStep()">Conferma e continua</button>
                        </div>
                    </div>
                </div>

                <div *ngIf="stato?.toLowerCase() === 'attesa accesso pde'">
                    <p>Confermare manualmente accesso PDE?</p>
                    <div class="d-flex">
                        <div style="margin-right: 0.5rem;">


                            <div class="mb-4 row g-3">
                                <div class="col-12">
                                    <mat-form-field style="width: 100%;">
                                        <mat-label>Data accesso PDE</mat-label>
                                        <input matInput [matDatepicker]="picker" [formControl]="dataAccesso">
                                        <mat-hint>GG/MM/AAAAA</mat-hint>
                                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class=" col-12">
                                    <mat-form-field style="width: 100%;">
                                        <mat-label>Note aggiuntive</mat-label>
                                        <textarea matInput [formControl]="noteAggiuntive"></textarea>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div>
                                <button mat-flat-button (click)="nextStepDataAccesso()">Conferma e continua</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="stato?.toLowerCase() === 'completata'">
                    <div class="d-flex">
                        <div style="margin-right: 0.5rem;">
                            <button mat-flat-button (click)="nextStep()">Concludi</button>
                        </div>
                    </div>
                </div>

                <div *ngIf="stato?.toLowerCase() === 'chiusa'">
                    <p>Richiesta completata e chiusa con successo.</p>
                </div>

                <div *ngIf="stato?.toLowerCase() === 'archiviata'">
                    <p>Richiesta archiviata.</p>
                </div>





            </mat-card-content>

        </mat-card>

    </div>

</div>